<template>
  <nav>
    <div class="pos-abs-fixed">
      <v-toolbar dense color="grey lighten-2">
        <v-toolbar-title>{{ pageTitle }}</v-toolbar-title>
        <v-divider
          class="mx-2"
          inset
          vertical
        ></v-divider>
        <v-layout row class="filtros-ativos" v-if="$vuetify.breakpoint.mdAndUp">
          <div class="text-xs-center">
            <v-chip dark :color="filtroAtivo === 'Não lidas' ? 'grey darken-1' : 'success'">{{ filtroAtivo }}</v-chip>
          </div>
        </v-layout>
        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <v-btn 
            flat icon small 
            slot="activator" 
            @click="$emit('atualizaListaNotificacoes')"
            :loading="loading"
          >
            <v-icon>refresh</v-icon>
          </v-btn>
          <span>Atualizar</span>
        </v-tooltip>

        <v-menu bottom left>
          <template v-slot:activator="{ on }">
            <v-tooltip bottom>
              <v-btn flat icon small slot="activator" v-on="on">
                <v-icon>filter_list</v-icon>
              </v-btn>
              <span>Filtrar</span>
            </v-tooltip>
          </template>

          <v-list dense subheader>
            <v-list-tile @click="filtraNaoLidas">
              <v-list-tile-title>
                Não lidas
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="filtraLidas">
              <v-list-tile-title>
                Lidas
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'HeaderNotificacao',
  props: ['pageTitle', 'loading'],
  data: () => ({
    filtroAtivo: 'Não lidas'
  }),
  methods: {
    filtraNaoLidas() {
      this.filtroAtivo = 'Não lidas';
      this.$emit('filtraStatusNotificacoes', 'P');
    },
    filtraLidas() {
      this.filtroAtivo = 'Lidas';
      this.$emit('filtraNotificacoesLidas', { tipo: 'hoje' });
    }
  }
}
</script>

<style scoped>
.pos-abs-fixed {
  z-index: 5;
  position: relative;
  padding-bottom: 40px;
}
.pos-abs-fixed > :first-child {
  position: fixed;
}
</style>